import { Config, AuthHeader } from "../helpers/Config";

export const BonusService = {
    /**
    * [APPLY_BONUS]
    * @param {object} data
    * @param {string} data.campaignName
    */
    Apply(data) {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }
        return BonusService.Common.Fetch(Config.service.bonus.apply, requestOptions);
    },
    /**
    * [COMMON]
    * @function Fetch
    */
    Common: {
        Fetch(url, requestOptions) {

            return fetch(url, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    else if (response.status === 401) {

                        window.location.reload();

                    } else {
                        throw new Error();
                    }
                }).then((json) => {
                    return json;
                }).catch(function () {
                    return false;
                });

        }
    }
}





